import { render, staticRenderFns } from "./DocFaceLibraryEdit.vue?vue&type=template&id=03546658&scoped=true"
import script from "./DocFaceLibraryEdit.vue?vue&type=script&lang=js"
export * from "./DocFaceLibraryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03546658",
  null
  
)

export default component.exports